export default {
  en: {
    chronofox_screenshots: "ChronoFox Screenshots",
    pdfandcsvreports_title: "PDF and CSV Reports",
    pdfandcsvreports_description:
      "Easily generate detailed PDF and CSV reports to stay on top of your data. Gain insights quickly and make informed decisions with comprehensive reports at your fingertips.",
    pdfandcsvreports_alt: "PDF and CSV report icons",

    manageableactivities_title: "Manageable Activities",
    manageableactivities_description:
      'Simplify time tracking and billing by managing activities like "Development." Set custom hourly rates, and track every task with ease to ensure accurate billing.',
    manageableactivities_alt: "Task list with different activities",

    revenuedashboards_title: "Revenue Dashboards",
    revenuedashboards_description:
      "See your earnings in real-time with clear and customizable dashboards. Break down revenue by activity, month, and more to keep a close eye on your business’s financial health.",
    revenuedashboards_alt: "Revenue dashboard showing graphs and statistics",

    manageablecustomers_title: "Manageable Customers",
    manageablecustomers_description:
      "Easily manage customer details, assign them to timelogs, and streamline billing. Say goodbye to billing headaches with intuitive customer management built for efficiency.",
    manageablecustomers_alt: "Customer profile management interface",

    digitalclock_title: "Digital Clock",
    digitalclock_description:
      "Stay focused on your work while our digital clock tracks your time effortlessly. Whether you’re working solo or managing a team, ensure every second is accounted for.",
    digitalclock_alt: "Digital clock displaying time",

    projects_title: "Projects",
    projects_description:
      "Take control of your projects with powerful management tools. Track budgets, monitor progress, and keep all your timelogs in one place for better oversight and project success.",
    projects_alt: "Project management interface",
  },
  de: {
    chronofox_screenshots: "ChronoFox Screenshots",
    pdfandcsvreports_title: "PDF- und CSV-Berichte",
    pdfandcsvreports_description:
      "Erstelle einfach detaillierte PDF- und CSV-Berichte, um deine Daten im Blick zu behalten. Erhalte schnell Einblicke und treffe fundierte Entscheidungen mit umfassenden Berichten, die dir zur Verfügung stehen.",
    pdfandcsvreports_alt: "PDF- und CSV-Bericht Symbole",

    manageableactivities_title: "Verwaltbare Aktivitäten",
    manageableactivities_description:
      "Vereinfache die Zeiterfassung und Abrechnung, indem du Aktivitäten wie „Entwicklung“ verwaltest. Lege individuelle Stundensätze fest und verfolge jede Aufgabe mühelos, um eine genaue Abrechnung sicherzustellen.",
    manageableactivities_alt: "Aufgabenliste mit verschiedenen Aktivitäten",

    revenuedashboards_title: "Umsatz-Dashboards",
    revenuedashboards_description:
      "Sieh deine Einnahmen in Echtzeit mit klaren und anpassbaren Dashboards. Teile den Umsatz nach Aktivität, Monat und mehr auf, um die finanzielle Gesundheit deines Unternehmens genau zu überwachen.",
    revenuedashboards_alt: "Umsatz-Dashboard mit Diagrammen und Statistiken",

    manageablecustomers_title: "Verwaltbare Kunden",
    manageablecustomers_description:
      "Verwalte Kundendaten ganz einfach, weise sie Zeiterfassungen zu und optimiere die Abrechnung. Verabschiede dich von Abrechnungsproblemen mit einer intuitiven Kundenverwaltung für mehr Effizienz.",
    manageablecustomers_alt:
      "Benutzeroberfläche zur Verwaltung von Kundenprofilen",

    digitalclock_title: "Digitale Uhr",
    digitalclock_description:
      "Bleibe fokussiert bei der Arbeit, während unsere digitale Uhr deine Zeit mühelos erfasst. Egal, ob du alleine arbeitest oder ein Team leitest – stelle sicher, dass jede Sekunde zählt.",
    digitalclock_alt: "Digitale Uhr mit Uhrzeit-Anzeige",

    projects_title: "Projekte",
    projects_description:
      "Behalte die Kontrolle über deine Projekte mit leistungsstarken Management-Tools. Verfolge Budgets, überwache Fortschritte und halte alle Zeiterfassungen an einem Ort für mehr Übersicht und Erfolg.",
    projects_alt: "Projektverwaltungs-Oberfläche",
  },
};
